import angular from 'angular';
import { dataTableComponent } from './dataTableComponent';
import 'components/sharpr/pagination/paginationModule';
import 'components/sharpr/sort/sortModule';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/url/data/urlDataModule';
import 'components/sharpr/clearableInput/clearableInputModule';

angular
	.module('sh.dataTable', ['sh.pagination', 'sh.sort', 'sh.api', 'sh.urlData', 'sh.clearableInput'])
	.component('shDataTable', dataTableComponent());
